import { AskRequest, AskResponse, GptChatRequest, ChatRequest, ChatResponse } from "./models";

export async function askApi(options: AskRequest): Promise<AskResponse> {
    const response = await fetch("/ask", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            question: options.question,
            approach: options.approach,
            overrides: options.overrides
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export async function searchdocApi(options: ChatRequest): Promise<AskResponse> {
    const response = await fetch("/docsearch", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            history: options.history,
            approach: options.approach,
            overrides: options.overrides
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}



export async function chatApi(options: GptChatRequest): Promise<ChatResponse> {

    const response = await fetch("/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            history: options.history,
            approach: options.approach,
            overrides: options.overrides,
            url_kname: options.url_kname,
            url_site: options.url_site
        })
    });

    const contentType = response.headers.get("content-type") || "";
    const responseText = await response.text();

    console.log("Chat API status出力:", response.status);
    console.log("Chat API content-type出力:", contentType);

    if (!response.ok) {
        console.error(
            "Chat API error出力:",
            response.status,
            responseText
        );

        throw new Error(`CHAT_API_ERROR出力:${response.status}`);
    }

    if (!contentType.includes("application/json")) {
        console.error(
            "Chat API returned non-JSON出力:",
            responseText
        );

        throw new Error("CHAT_API_NON_JSON出力");
    }

    try {
        return JSON.parse(responseText);
    } catch (e) {
        console.error(
            "Chat API JSON parse error出力:",
            responseText
        );

        throw new Error("CHAT_API_INVALID_JSON出力");
    }
}

export async function chatApi_old(options: GptChatRequest): Promise<ChatResponse> {
    const response = await fetch("/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            history: options.history,
            approach: options.approach,
            overrides: options.overrides,
            url_kname: options.url_kname,
            url_site: options.url_site
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}


export function getCitationFilePath(citation: string): string {
    return `/content/${citation}`;
}
